import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Pagar } from '@app/models/pagar.model';
import { PagarService } from '@app/services/pagar.service';
import { Processo } from '@app/models/processo.model';
import { ProcessoService } from '@app/services/processo.service';
import { ConsultasService } from '@app/services/consultas.service';

import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '@app/services/usuario.service';

import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { IdDescricao } from '@app/models/util/id-descricao';

@Component({
  selector: 'app-pagar-form',
  templateUrl: './pagar-form.component.html',
})
export class PagarFormComponent implements OnInit {
  aguardandoSolicitacao:boolean=false
  acessoOutrasUnidades: boolean;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pagarService: PagarService,
    private consultasService: ConsultasService,
    private processoService: ProcessoService,
    @Inject(ToastrService) public toastr: ToastrService,
    private usuarioService: UsuarioService,
    private usuarioTipoService: UsuarioTipoService

  ) {
    this.pagar = new Pagar();
    // this.pagar.DemonstrativoDeResultadoId = null;
    const hoje = new Date();
    this.pagar.Emissao = hoje.toISOString().split('T')[0];
    this.pagar.Vencimento = hoje.toISOString().split('T')[0];
    this.pagar.Valor = 0;
    this.pagar.NumeroCopias = 1;

  }

  pagar: Pagar;

  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];
  processoId: number;
  titulo: string;

  //usuarioLogadoId = 0;
  //renataId = 20789;
  acessoLiberarPagamento: boolean;

  gerarFatura = false;

  faturaQntParcela = 0;
  faturaIntervalorDias = 30;

  acessoAOutrasUnidades = true;
  edicaoPagar = false

  lstUnidade: Array<any> = [{}];
  lstParticipante: Array<any> = [{}];
  lstTipoDR: Array<any> = [{}];

  _debounce: any;
  _pesquisa: any;

  ngOnInit() {
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidade = data);
    this.consultasService.consultar('DR_D').toPromise().then(data => this.lstTipoDR = data);
    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoOutrasUnidades = permissoes.find(x => x.Descricao == 'VisualizarOutrasUnidades').Selecionado;
      });

    this.route.params.subscribe(
      (params: any) => {
        const id = params['id'];
        this.processoId = params['processoid'];
        this.titulo = id ? 'Editar contas a pagar ' : 'Lançar contas a pagar';
        // novo
        if (!id) {
          // verifica se é pela tela de processo
          if(this.processoId != undefined) {
            this.obterProcesso();
          }else{
            this.pagar.UnidadeId = Number(UtilitarioService.retornaUnidadeUsuario());
          }
          // this.obterUnidades();
          // this.unidadeService.obterUnidadeUsuarioLogado().subscribe(data => this.pagar.UnidadeId = data);
        } else {
          // editar
          this.pagarService.obterPorId(id).toPromise().then(data => {
            this.edicaoPagar = true
            this.pagar = data;
            this.pagar.Emissao = this.pagar.Emissao.split('T')[0];
            this.pagar.Vencimento = this.pagar.Vencimento.split('T')[0];
            if (this.pagar.Participante) {
              this.lstParticipante = [{ Id: this.pagar.ParticipanteId, Descricao: this.pagar.Participante.NomeFantasia }];
            }
          });
          if(this.processoId > 0) {
            this.acessoAOutrasUnidades = false;
          }
        }
      });
      // this.usuarioService.obterUsuarioLogado().toPromise()
      //   .then(idLogado => {
      //     this.usuarioLogadoId = idLogado;
      //   }
      // );
      this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
        (permissoes: any) =>{
          this.acessoLiberarPagamento = permissoes.find(x => x.Descricao == 'LiberarPagamento').Selecionado;
        });
  }

  obterProcesso() {
    if (!this.processoId) {
      return;
    }

    this.processoService.obterPorId(this.processoId).subscribe(
      (data: Processo) => {
        if (data != null) {
          this.pagar.ProcessoId = data.Id;
          this.pagar.ParticipanteId = data.ClienteId;
          this.pagar.UnidadeId = data.UnidadeId;
          this.lstParticipante = [{ Id: data.ClienteId, Descricao: data.ClienteNome }];
        } else {
          this.router.navigate(['/dashboard']);
        }
      },
      () => this.router.navigate(['/dashboard']));
  }

  btnGerarFaturas() {
    if (this.pagar.Id !== 0) {
      this.gerarFatura = true;
    } else {
      this.toastr.error('Salve o contas a pagar antes de gerar as faturas', 'Notificação!');
    }
  }
  liberar() {
    const _pagar = { ...this.pagar };
    _pagar.Participante = null;
    _pagar.PagamentoLiberado = true;
    this.pagarService.gravar(_pagar)
      .toPromise().then(
        () => {
          window.history.go(-1);
        },
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
        });
  }

  confirmarEnvioFaturas() {
    if (this.faturaQntParcela > 0 && this.faturaIntervalorDias > 0) {
      this.pagarService.gerarFaturas(this.pagar.Id, this.faturaQntParcela, this.faturaIntervalorDias)
        .subscribe(
          () => {
            this.toastr.success('Sucesso ao gerar faturas', 'Notificação!');
            this.gerarFatura = false;
            this.pagar.Parcela = 1 + '/' + this.faturaQntParcela;
            this.lstErros = [];
          },
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
          });
    } else {
      this.toastr.error('Preencha a quantidade de parcelas e o intervalo de dias corretamente', 'Notificação!');
    }
  }

  gravar() {
    this.aguardandoSolicitacao = true;
    const _pagar = { ...this.pagar };
    if(_pagar.Id === 0 && _pagar.ProcessoId === undefined){
      _pagar.PagamentoLiberado = true;
    }
    _pagar.Participante = null;
    this.pagarService.gravar(_pagar)
      .toPromise().then(
        () => {
          this.redirecionar();
        },
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        });
  }

  btnVoltar() {
    this.redirecionar();
  }

  private redirecionar() {
    if (this.processoId > 0) {
      this.router.navigate(['/processos/processo', this.pagar.ProcessoId, 'financeiro']);
    } else {
      this.router.navigate(['/financeiro/pagar']);
    }
  }
}


function confirmarEnvioFaturas(): any {
  throw new Error('Function not implemented.');
}

